export default {
    addTeamMember: 'メンバーを招待',
    administrator: '管理者',
    approveDocuments: '書類を承認',
    createEditDeleteAnApprovalFlow: '承認フローの作成／編集／削除',
    documentApproval: '書類の承認',
    documents: '書類の承認',
    group: 'グループ',
    groupHelpText:
        '取引先に担当グループを設定すると、取引先や関連書類、レポートが所属メンバーにのみ表示されます。',
    headerText0:
        'この方をMakeLeapsにて{{companyName}}に招待を行おうとしています。新メンバーのメールアドレスをご入力ください。入力されたメールアドレスに招待状としてアカウント登録のリンクが送信されます。',
    headerText1: 'このメンバーは御社のデータを閲覧できるようになります。',
    other: 'その他',
    requestApprovalForDocuments: '書類の承認を依頼',
    salesManagement: '販売管理',
    salesManagementHelpText:
        '販売管理とは、書類を作成、管理、送付できるMakeLeapsの標準システムです。',
    save: 'メンバーの権限を保存',
    timeTracking: '作業時間管理',
    timeTrackingHelpText:
        '作業時間管理が有効になると、自動的に作業報告書の作成/編集/削除、無効化権限が付与されます。',
    upgrade:
        '一般権限の上限を超過しています。一般権限数を増やすには、<0>アップグレード</0>をご検討ください。',
    userLicense: '利用権限',
    whatIsTimeTracking: '作業時間管理とは',
};
